import {CssBaseline, Modal as GWCModal, ThemeProvider as GWCThemeProvider, LocaleContext} from '@gwc/main'
import React, {useMemo} from 'react'
import {config} from 'src/shared/config'
import {useTheme} from 'src/shared/hooks'

import {getGwcTheme} from './gwc-theme'

type Props = {
  children: React.ReactNode
}

/**
 * GWC ThemeProvider: выставляет --colorScheme-* на :root через runtime <style>.
 * Тема синхронизирована с resolveTheme / data-theme (см. useTheme).
 */
export function RouteThemeProvider({children}: Props): React.ReactElement {
  const mode = useTheme()
  const gwcTheme = useMemo(() => getGwcTheme(mode, config.dir), [mode])

  return (
    <GWCThemeProvider isGlobal theme={gwcTheme}>
      <GWCModal.Provider>
        <LocaleContext locale={config.lang}>
          <CssBaseline />
          {children}
        </LocaleContext>
      </GWCModal.Provider>
    </GWCThemeProvider>
  )
}
